var _defs, _path, _circle, _circle2, _line, _line2, _line3, _path2, _g, _g2, _circle3, _circle4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRadarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:.75px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.61483,10.48712c0,4.48222-3.63261,8.11483-8.11483,8.11483S2.38517,14.96935,2.38517,10.48712,6.01778,2.37229,10.5,2.37229c1.57789,0,3.04307,.45079,4.29151,1.23108-.14737,.19939-.22542,.43349-.22542,.69357,0,.66758,.53752,1.2051,1.2051,1.2051,.32945,0,.62419-.13007,.84094-.34681,1.24844,1.43052,2.0027,3.29453,2.0027,5.33189Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 10.5,
    cy: 15.08475,
    r: 3.51583
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 10.5,
    cy: 12.66798,
    r: 5.93261
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 3.68431,
    y1: 5.71022,
    x2: 10.5,
    y2: 18.60058
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 17.31569,
    y1: 5.93368,
    x2: 10.5,
    y2: 18.82404
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10.5,
    y1: 2.37366,
    x2: 10.5,
    y2: 18.60058
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.98492,4.29694c0,.33813-.14737,.65023-.37279,.85829-.21674,.21674-.51148,.34681-.84094,.34681-.66758,0-1.2051-.53752-1.2051-1.2051,0-.26008,.07805-.49418,.22542-.69357,.20806-.3121,.57218-.52016,.97968-.52016,.66753,0,1.21373,.5462,1.21373,1.21373Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 15.77452,
    y1: 3.08719,
    x2: 15.77452,
    y2: 1.98237
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 15.77452,
    y1: 6.60877,
    x2: 15.77452,
    y2: 5.50396
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 16.98291,
    y1: 4.29557,
    x2: 18.08772,
    y2: 4.29557
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 13.46132,
    y1: 4.29557,
    x2: 14.56613,
    y2: 4.29557
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 7.1942,
    cy: 5.36874,
    r: 0.74805
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 12.46219,
    cy: 9.53192,
    r: 0.74805
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadarIcon);
export default __webpack_public_path__ + "static/media/radar-icon.32350ec6af6e14221a802169eea055e3.svg";
export { ForwardRef as ReactComponent };